module.exports = __webpack_public_path__ + "static/media/15UN-Habitat3.0dd5ef35.jpg";